import { FC, Fragment } from 'react';
import { Add as AddIcon, Delete } from '@mui/icons-material';
import { Box, Button, Card, Grid, IconButton, Link, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
// component
import NoDataCard from 'components/common/NoDataCard';
import DataLoader from 'components/common/DataLoader';
import InputController from 'controller/InputController';
// styles, interface, constants
import { AddNewIngredientFormType, SubComponentTabProps } from 'interfaces';
import { forInputLabelBg, textDecoration } from 'styles/commonComponentStyle';
import { displayFlexAlignCenter, flexCenterJustifyBetween } from 'theme/styleConstant';
import {
  ADD_TEXT,
  SAVE_TEXT,
  NAME_TEXT,
  PERCENTAGE_TEXT,
  NO_SUB_COMPONENT_TEXT,
  subComponentSelectTypeInitialValue,
} from 'constants/index';

const SubComponentsCard: FC<SubComponentTabProps> = ({ loading, isEdit }) => {
  const { control } = useFormContext<AddNewIngredientFormType>();

  const { fields, remove, append } = useFieldArray({
    name: 'subComponents',
    control,
  });

  const handleAddItem = () => {
    append(subComponentSelectTypeInitialValue);
  };

  const handleRemoveItem = (index: number) => {
    remove(index);
  };

  return (
    <Card sx={forInputLabelBg}>
      {loading ? (
        <DataLoader columns={6} rows={21} />
      ) : (
        <>
          {fields?.length ? (
            <Grid container spacing={3}>
              {fields?.map((item, index) => (
                <Fragment key={item.id}>
                  <Grid item xs={12} lg={5}>
                    <InputController
                      isRequired
                      fieldType="text"
                      disabled={loading}
                      title={NAME_TEXT}
                      name={`subComponents.[${index}].name`}
                    />
                  </Grid>

                  <Grid item xs={12} lg={5}>
                    <InputController
                      isRequired
                      fieldType="number"
                      disabled={loading}
                      title={PERCENTAGE_TEXT}
                      name={`subComponents.[${index}].percentage`}
                    />
                  </Grid>

                  <Grid item xs={12} lg={1} mt={1}>
                    <IconButton color="error" aria-label="delete" onClick={() => handleRemoveItem(index)}>
                      <Delete />
                    </IconButton>
                  </Grid>
                </Fragment>
              ))}
            </Grid>
          ) : (
            <NoDataCard title={NO_SUB_COMPONENT_TEXT} />
          )}

          <Box sx={flexCenterJustifyBetween} mt={1.5}>
            <Link
              component="button"
              type="button"
              disabled={loading}
              onClick={handleAddItem}
              sx={[displayFlexAlignCenter, textDecoration]}>
              <AddIcon />
              <Typography variant="caption" pl={0.5} fontWeight={600}>
                {ADD_TEXT}
              </Typography>
            </Link>

            {isEdit && (
              <Button type="submit" variant="contained" id="allergen-btn" size="small" disabled={loading}>
                {SAVE_TEXT}
              </Button>
            )}
          </Box>
        </>
      )}
    </Card>
  );
};

export default SubComponentsCard;
